import { render, staticRenderFns } from "./ServicePolicy.vue?vue&type=template&id=3c2ee80f&scoped=true&"
import script from "./ServicePolicy.vue?vue&type=script&lang=js&"
export * from "./ServicePolicy.vue?vue&type=script&lang=js&"
import style0 from "./ServicePolicy.vue?vue&type=style&index=0&id=3c2ee80f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ee80f",
  null
  
)

export default component.exports